import { render } from "./TabView.vue?vue&type=template&id=08bc5d64&scoped=true&ts=true"
import script from "./TabView.vue?vue&type=script&lang=ts"
export * from "./TabView.vue?vue&type=script&lang=ts"

import "./TabView.vue?vue&type=style&index=0&id=08bc5d64&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bc5d64"]])

export default __exports__